import api, { LOCALE_HOST } from '@whitelabel/xcover-shared/helpers/api';
import { getNestAPIHost } from '@whitelabel/xcover-shared/helpers/multiRegion';
import { MESSAGE_SLUGS } from '@whitelabel/xcover-shared/helpers/constants';
import { retry } from './utils';

export const loadFEMessages = (
  locale: string,
  slug: string = MESSAGE_SLUGS.FE_MESSAGES_SLUG,
  requestInit?: RequestInit,
): any =>
  retry(() =>
    api.get(
      `${LOCALE_HOST}${getNestAPIHost()}/messages/frontend/${slug}/?language=${locale}`,
      false,
      requestInit || {},
    ),
  );
